import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import {
  capitalizeFirstLetter,
  formateDate,
} from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import {
  Details,
  GetRatings,
  DeleteRatings,
} from "../../services/psychic.services";
import Breadcrums from "../../common/breadcrumbs";
import { AllLanguages, SWAL_SETTINGS } from "../../../../utils/Constants";
import CustomPagination from "../../common/custompagination";
import Swal from "sweetalert2";

const AstrologerView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [ratingsList, setRatingsList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [ratingsLoader, setRatingsLoader] = useState(false);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Astrologer"),
      url: "/admin/astrologer-management/astrologer/list/1",
    },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  useEffect(() => {
    if (params.id) {
      fetchRatings(page);
    }
  }, [params.id, page]);

  const fetchRatings = (pg) => {
    setRatingsLoader(true);
    const payload = {
      astrologer_id: params.id,
      page: pg,
      per_page: itemPerPage,
    };
    GetRatings(payload)
      .then((res) => {
        if (res && res.success) {
          setRatingsList(res.data.list || []);
          setTotalRecords(res.data.total_records || 0);
        }
        setRatingsLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching ratings:", err);
        setRatingsLoader(false);
      });
  };

  const handleDeleteRating = (id) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteRatings({ id: id })
          .then((res) => {
            if (res && res.success) {
              Swal.fire({
                icon: "success",
                text: res.message,
                ...SWAL_SETTINGS,
              });
              fetchRatings(page);
            } else {
              Swal.fire({
                icon: "error",
                text: res.message || "Error deleting rating",
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((err) => {
            console.error("Error deleting rating:", err);
            Swal.fire({
              icon: "error",
              text: "An error occurred while deleting the rating",
              ...SWAL_SETTINGS,
            });
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Image")}</th>
                          <td>
                            <img
                              src={
                                showdefault && showdefault.profile_image
                                  ? showdefault.profile_image
                                  : "N/A"
                              }
                              alt="profile"
                              style={{ height: "100px" }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? showdefault.name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Screen Name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.screen_name
                              ? showdefault.screen_name
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("About Me")}</th>
                          <td>
                            {showdefault && showdefault.about_me
                              ? showdefault.about_me
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("System")}</th>
                          <td>
                            {(() => {
                              if (!showdefault || !showdefault.system) return "N/A";
                              let sysList = Array.isArray(showdefault.system) ? showdefault.system : [];
                              if (typeof showdefault.system === "string") {
                                try {
                                  const parsed = JSON.parse(showdefault.system);
                                  if (Array.isArray(parsed)) sysList = parsed;
                                  else sysList = showdefault.system.split(",");
                                } catch (e) {
                                  sysList = showdefault.system.split(",");
                                }
                              }
                              sysList = sysList.map(s => String(s).trim()).filter(Boolean);
                              return sysList.length > 0
                                ? sysList.map((sys, idx) => (
                                    <span key={idx} className="badge bg-primary me-1">{sys}</span>
                                  ))
                                : "N/A";
                            })()}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Chart")}</th>
                          <td>
                            {showdefault && (showdefault.chart_type || showdefault.chart)
                              ? (showdefault.chart_type || showdefault.chart)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Service Provided")}</th>
                          <td>
                            {showdefault?.service_type === "chat"
                              ? t("Only Chat")
                              : showdefault?.service_type === "call"
                              ? t("Only Call")
                              : showdefault?.service_type === "video_call" || showdefault?.service_type === "video"
                              ? t("Only Video Call")
                              : showdefault?.service_type === "chat_video"
                              ? t("Chat & Video Call")
                              : showdefault?.service_type === "call_video"
                              ? t("Call & Video Call")
                              : showdefault?.service_type === "all"
                              ? t("All (Chat, Call & Video Call)")
                              : t("Both (Chat & Call)")}
                          </td>
                        </tr>

                        {showdefault?.email && (
                          <tr>
                            <th>{t("label_email")}</th>
                            <td>
                              {showdefault && showdefault.email
                                ? showdefault.email
                                : "N/A"}
                            </td>
                          </tr>
                        )}
                        {showdefault?.phone_number && (
                          <tr>
                            <th>{t("label_phone_number")}</th>
                            <td>
                              {showdefault && showdefault?.phone_number
                                ? showdefault.phone_number
                                : "N/A"}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th>{t("Expertise")}</th>
                          <td>
                            {showdefault?.expertise &&
                            Array.isArray(showdefault.expertise) &&
                            showdefault.expertise.length > 0 ? (
                              showdefault.expertise.map((item, index) => {
                                const expertiseType =
                                  item?.category?.title ||
                                  item?.expertise_type ||
                                  item?.type ||
                                  item?.name ||
                                  "";
                                return expertiseType ? (
                                  <span
                                    key={index}
                                    className="badge bg-primary me-1"
                                  >
                                    {expertiseType}
                                  </span>
                                ) : null;
                              })
                            ) : (
                              <span className="text-muted">N/A</span>
                            )}
                          </td>
                        </tr>

                        {/* <tr>
                          <th>{t("Online Puja")}</th>
                          <td>
                            {showdefault && showdefault?.online_puja && Array.isArray(showdefault.online_puja) && showdefault.online_puja.length > 0 ?
                              showdefault.online_puja.map((item, index) => {
                                const price = parseFloat(item?.price_per_minute);  // Convert string to number
                                return (
                                  !isNaN(price) && price > 0 && item?.price_per_minute ? (
                                    <span key={index} className="badge bg-primary me-1">
                                      {item?.puja_type} - ₹{price.toFixed(2)} / min
                                    </span>
                                  ) : "-"
                                );
                              })
                              : "N/A"}
                          </td>
                        </tr> */}

                        <tr>
                          <th>{t("Experience")}</th>
                          <td>
                            {showdefault && showdefault?.experience
                              ? showdefault.experience + " years"
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Education")}</th>
                          <td>
                            {showdefault && showdefault?.education
                              ? showdefault.education
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Language spoken")}</th>
                          <td>
                            {(() => {
                              const langArray =
                                showdefault?.languages &&
                                Array.isArray(showdefault.languages) &&
                                showdefault.languages.length > 0
                                  ? showdefault.languages
                                  : showdefault?.language_spoken &&
                                    Array.isArray(showdefault.language_spoken)
                                  ? showdefault.language_spoken.map((l) => ({
                                      language: l,
                                    }))
                                  : [];
                              return langArray.length > 0 ? (
                                langArray.map((item, index) => {
                                  const langRaw =
                                    typeof item === "string"
                                      ? item
                                      : item?.language ||
                                        item?.language_name ||
                                        item?.name ||
                                        "";
                                  const langStr =
                                    typeof langRaw === "object"
                                      ? langRaw.name || langRaw.code || ""
                                      : String(langRaw || "");
                                  const display = AllLanguages[langStr] || langStr;
                                  return (
                                    <span
                                      key={index}
                                      className="badge bg-primary me-1"
                                    >
                                      {typeof display === "object"
                                        ? display.name || display.code || "N/A"
                                        : display}
                                    </span>
                                  );
                                })
                              ) : (
                                <span className="text-muted">N/A</span>
                              );
                            })()}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Preferred Language")}</th>
                          <td>
                            {(() => {
                              const pref = showdefault?.preferred_language;
                              if (!pref) return "N/A";
                              if (typeof pref === "object") {
                                if (pref.name && pref.name.toLowerCase() !== "[object object]") return pref.name;
                                if (pref.code && pref.code.toLowerCase() !== "[object object]") return pref.code;
                                return "N/A";
                              }
                              const str = String(pref).trim();
                              if (str.toLowerCase() === "[object object]") return "N/A";
                              return AllLanguages[str] || str;
                            })()}
                          </td>
                        </tr>

                        {/* <tr>
                          <th>Admin Rating</th>
                          <td>
                            {showdefault && showdefault?.rating
                              ? showdefault.rating
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>User Average Rating</th>
                          <td>
                            {showdefault && showdefault?.average_rating
                              ? showdefault.average_rating
                              : "N/A"}
                          </td>
                        </tr> */}

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Free Status")}</th>
                          <td>
                            {showdefault?.is_free ? (
                              <span className="badge bg-success">Free</span>
                            ) : (
                              <span className="badge bg-secondary">
                                Not Free
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Gallery Photos Section */}
                    <h6 className="main-content-label mt-4 mb-3">
                      {t("Gallery Photos")}
                    </h6>
                    {(() => {
                      let photos = showdefault?.gallery_photo || [];
                      if (typeof photos === "string") {
                        try {
                          photos = JSON.parse(photos);
                        } catch {
                          photos = [];
                        }
                      }
                      if (!Array.isArray(photos) || photos.length === 0) {
                        return (
                          <p className="text-muted">
                            No gallery photos available.
                          </p>
                        );
                      }
                      return (
                        <div className="row">
                          {photos.map((photo, index) => {
                            const src =
                              typeof photo === "string"
                                ? photo
                                : photo?.image ||
                                  photo?.url ||
                                  photo?.path ||
                                  "";
                            if (!src) return null;
                            const imgSrc = src.startsWith("http")
                              ? src
                              : `${process.env.REACT_APP_API_URL || ""}/${src}`;
                            return (
                              <div
                                key={index}
                                className="col-lg-3 col-md-4 col-sm-6 mb-3"
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    height: "160px",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    background: "#f8f8f8",
                                  }}
                                >
                                  <img
                                    src={imgSrc}
                                    alt={`Gallery ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      height: "160px",
                                      objectFit: "cover",
                                      display: "block",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      window.open(imgSrc, "_blank")
                                    }
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}

                    {/* Documents & Video Section */}
                    <h6 className="main-content-label mt-5 mb-3">
                      {t("Documents & Promotional Video")}
                    </h6>
                    <div className="row">
                      {/* ID Proof */}
                      {showdefault?.id_proof && (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                          <label className="fw-bold mb-2 d-block">
                            {t("ID Proof")}
                          </label>
                          <button
                            className="btn btn-outline-primary btn-sm ripple"
                            onClick={() =>
                              window.open(showdefault.id_proof, "_blank")
                            }
                          >
                            <i className="fa fa-file-text me-2"></i>
                            {t("View ID Proof")}
                          </button>
                        </div>
                      )}

                      {/* Certifications */}
                      {showdefault?.certifications && (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                          <label className="fw-bold mb-2 d-block">
                            {t("Certifications")}
                          </label>
                          <button
                            className="btn btn-outline-primary btn-sm ripple"
                            onClick={() =>
                              window.open(showdefault.certifications, "_blank")
                            }
                          >
                            <i className="fa fa-certificate me-2"></i>
                            {t("View Certifications")}
                          </button>
                        </div>
                      )}

                      {/* Bank Cheque */}
                      {showdefault?.bank_cheque && (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                          <label className="fw-bold mb-2 d-block">
                            {t("Bank Cheque")}
                          </label>
                          <button
                            className="btn btn-outline-primary btn-sm ripple"
                            onClick={() =>
                              window.open(showdefault.bank_cheque, "_blank")
                            }
                          >
                            <i className="fa fa-university me-2"></i>
                            {t("View Bank Cheque")}
                          </button>
                        </div>
                      )}

                      {/* Promotional Video */}
                      {showdefault?.promotional_video && (
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                          <label className="fw-bold mb-2 d-block">
                            {t("Promotional Video")}
                          </label>
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "250px",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              overflow: "hidden",
                              background: "#000",
                            }}
                          >
                            <video width="100%" height="auto" controls>
                              <source
                                src={showdefault.promotional_video}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Ratings & Reviews Section */}
                    <h6 className="main-content-label mt-5 mb-3">
                      {t("User Ratings & Reviews")}
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                        <thead>
                          <tr>
                            <th>{t("list_heading_sno")}</th>
                            <th>{t("User")}</th>
                            <th>{t("Rating")}</th>
                            <th>{t("Feedback")}</th>
                            <th>{t("Date")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ratingsLoader ? (
                            <tr>
                              <td colSpan="5">
                                <Loader />
                              </td>
                            </tr>
                          ) : (
                            <>
                              {ratingsList.length > 0 ? (
                                ratingsList.map((row, i) => (
                                  <tr key={i}>
                                    <td>{(page - 1) * itemPerPage + i + 1}</td>
                                    <td>
                                      {row?.reviewer_name ||
                                        row?.user?.name ||
                                        "N/A"}
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        {[...Array(5)].map((_, index) => (
                                          <i
                                            key={index}
                                            className={`fa fa-star ${index < row.rating ? "text-warning" : "text-light"}`}
                                          ></i>
                                        ))}
                                        <span className="ms-2">
                                          ({row.rating})
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      className="text-wrap"
                                      style={{ maxWidth: "300px" }}
                                    >
                                      {row.feedback || "No feedback provided"}
                                    </td>
                                    <td>
                                      {row.createdAt
                                        ? formateDate(row.createdAt)
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <button
                                        className="btn btn-sm ripple btn-secondary"
                                        onClick={() =>
                                          handleDeleteRating(row.id)
                                        }
                                      >
                                        <i className="fa fa-trash me-1"></i>
                                        {t("btn_delete")}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    className="text-center text-muted"
                                  >
                                    {t("No ratings available yet.")}
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {totalRecords > itemPerPage && (
                      <div className="mt-3">
                        <CustomPagination
                          datalength={totalRecords}
                          itemperpage={itemPerPage}
                          currentPage={page}
                          setPage={setPage}
                          modalPagination={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="mt-2 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  // navigate("/admin/psychic-management/psychic/list/1")
                  navigate(-1)
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AstrologerView;
